// Customizable Area Start
import React from "react";
import {
  Box,
  Button,
  FormControlLabel,
  RadioGroup,
  Typography,
  Container,
  Switch,
  CircularProgress,
} from "@material-ui/core";
import { Info } from "@material-ui/icons";
import StyledRadioBtn from "./StyledRadioBtn.web";
import {
  PaymentPlan,
  PlanPricing,
  configJSON,
} from "./EmailAccountRegistrationController.web";
import { withStyles, createStyles, Theme } from "@material-ui/core/styles";
import PlanPaymentController from "./PlanPaymentController.web";
import { payment_start } from "./assets";
interface Props {
  setSelectedPlan: (plan: any) => void;
}

const webStyles: Record<string, any> = {
  mainContainerForm: {
    display: "flex",
    width: "1018px",
    gap: "41px",

    fontFamily: "Roboto, Inter, Arial, sans-serif",
    "@media: (max-width: 950px)": {
      flexDirection: "column"
    }
  },
  fromGrid: {
    width: "100%",
    height: "fit-content",
    marginRight: "15px",
    marginTop: "25px",
  },
  radioGroupBlock: {
    display: "flex",
    justifyContent: "center",
    padding: "16px 0 24px",
  },
  strikethrougnBlock: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    marginRight: "8px",
    marginBottom: "2px",
    paddingLeft: "7px",
    fontSize: "20px",
    fontWeight: 700,
    color: "#CBD5E1",
  },
  radioButtons: {
    display: "flex",
    "@media (max-width: 950px)": {
      flexDirection: "column"
    }
  },

  planPaymentBlock: {
    display: "flex",
    justifyContent: "center",
  },

  paymentPlan: {
    display: "flex",
    flexDirection: "column",
    width: "312px",
    border: "1px solid #ABB0BC",
    borderRadius: "20px",
    color: "#475569",
    padding: "20px 15px 25px",
    marginBottom: "20px",
  },

  descriptionList: {
    paddingInlineStart: "20px",
    marginBlockStart: 0,
  },

  descriptionText: {
    color: "#475569",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "19.5px",
  },

  hideMark: {
    listStyleType: "none",
    paddingInlineStart: "20px",
  },

  standardPlan: {
    border: "6px solid #000000",
  },

  titleText: {
    color: "#0F172A",
    fontWeight: 700,
    marginLeft: "17px",
    marginBottom: "37px",
  },

  priceBlock: {
    display: "flex",
    alignItems: "flex-end",
    paddingLeft: "15px",
    marginBottom: "30px",
    flexWrap: "wrap",
  },

  strikethroughLine: {
    position: "absolute",
    width: "100%",
    top: "45%",
    height: "3px",
    backgroundColor: "#CBD5E1",
  },

  oldPrice: {
    fontWeight: 700,
    fontSize: "20px",
    lineHeight: "25px",
  },

  price: {
    display: "flex",
    alignItems: "flex-end",
    fontSize: "20px",
    fontWeight: 700,
    color: "#000",
    wordBreak: "normal",
  },

  extraSize: {
    fontSize: "36px",
    lineHeight: "36px",
  },

  priceAttributes: {
    display: "flex",
    flexDirection: "column",
    paddingBottom: "3px",
  },

  priceCurrency: {
    textTransform: "capitalize",
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "14px",
    letterSpacing: "-0.12px",
  },

  priceInterval: {
    fontSize: "20px",
    lineHeight: "20px",
    fontWeight: 700,
  },

  advantageList: {
    flexGrow: 1,
    marginBottom: "30px",
  },

  advantageItem: {
    marginBottom: "28px",
  },

  permissionText: {
    marginBottom: "21px",
    color: "#475569",
    fontFamily: "inherit",
    fontSize: "14px",
    fontStyle: "inherit",
    fontWeight: 400,
    lineHeight: "19.5px",
  },

  selectBtn: {
    fontWeight: 700,
    backgroundColor: "#FFC629",
    textTransform: "capitalize",
    borderRadius: "8px",
    height: "44px"
  },

  divider: {
    width: "1px",
    height: "100%",
    backgroundColor: "#C0C4CD",
    marginRight: "20px",
    marginLeft: "20px",
  },

  discountText: {
    color: "#0A66C2",
  },

  infoButton: {
    display: "flex",
    alignItems: "center" as "center",
    justifyContent: "center",
    width: "18px",
    height: "18px",
    padding: "2px",
    marginLeft: "auto",
    borderRadius: "100%",
    backgroundColor: "#FFC629",
  },

  infoText: {
    color: "#475569",
    fontSize: "14px",
    fontWeight: 900,
  },

  tooltipRegular: {
    color: "#475569",
    fontSize: "14px",
  },

  tooltipBold: {
    color: "#475569",
    fontSize: "14px",
    fontWeight: 700,
  },
};

const styles = (theme: Theme) =>
  createStyles({
    container:{
      margin: "20px 0"
    },
    formLabel: {
      borderRadius: "5px",
      padding: "5px 25px 5px 16px",
    },
    formLabelActive: {
      backgroundColor: "#D9D9D9",
      marginRight: "0px",
    },
    hide: {
      [theme.breakpoints.down(768)]: {
        display: "none",
      },
    },
    mainContainerForm:{
      display: "flex",
      width: "1018px",
      gap: "41px",
  
      fontFamily: "Roboto, Inter, Arial, sans-serif",
      [theme.breakpoints.down(1018)]: {
        flexWrap: "wrap"
      },
      [theme.breakpoints.down(768)]: {
        flexDirection: "column",
        alignItems: "center"
      },
    },
    mobileView:{
      margin: "20px 20px",
      display: "none",
      [theme.breakpoints.down(768)]: {
        display: "block"
      },
      "& .header": {
        fontSize: "20px",
        fontWeight: 700,
      }
    },
    progressImage:{
      margin: "24px auto",
      "& img": {
        width: "100%"
      },
      [theme.breakpoints.up(768)]: {
        display: "none"
      }
    },

    platformManagementContainer: {
      display: "flex",
      alignItems: "center",
      paddingBottom: "30px",
      gap: "5px",
    },

    infoContainer: {
      display: "flex",
      position: "relative",
      alignItems: "center",
      justifyContent: "center",
    },

    tooltip: {
      display: "none",
      position: "absolute",
      bottom: "28px",
      left: "8px",
      width: "236px",
      padding: "15px 12px",
      borderRadius: "20px 20px 20px 0",
      backgroundColor: "#FFC629",
      color: "#475569",
      fontSize: "10px",
      fontWeight: 400,
      lineHeight: "14.5px",
    },

    tooltipText: {
      "& + span": {
        fontWeight: 700,
      },
    },

    iconContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "18px",
      height: "18px",
      borderRadius: "50%",
      backgroundColor: "#475569",

      "&:hover + *": {
        display: "block",
      },

      "& > *": {
        width: "22px",
        height: "22px",
      },
    },

    infoIcon: {
      "&.MuiSvgIcon-root": {
        fill: "#FFC629",
        borderRadius: "50%",
      },
    },

    platformManagementDescription: {
      color: "#475569",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "19.5px",
    },

    platformManagementSwitch: {
      width: "60px",
      height: "38px",
      padding: "5px",

      "& .MuiSwitch-thumb": {
        width: "26px",
        height: "26px",
        color: "#FFF",
      },

      "& .MuiSwitch-track": {
        border: "1px solid #D1D3D9",
        borderRadius: "14px",
      },

      "& .MuiSwitch-switchBase": {
        padding: "7px",
      },

      "& .MuiSwitch-colorSecondary.Mui-checked": {
        color: "#FFF",
      },
      "& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track": {
        backgroundColor: "#FFC629",
        opacity: 1,
      },
    },
  });

class PlanPayment extends PlanPaymentController {
  render() {
    const {
      classes,
      platformManagementChecked,
      setPlatformManagement,
      setSelectedPricing,
      selectedPricing,
      paymentPlanData,
      platformManagementPaymentPlans,
    }: any = this.props;
    const { activeBoxIndex, loadingPlanId } = this.state;

    // Debug logging
    console.log("🔍 PlanPayment Debug Info:");
    console.log("📊 paymentPlanData:", paymentPlanData);
    console.log("💰 selectedPricing:", selectedPricing);
    console.log("🔧 platformManagementChecked:", platformManagementChecked);

    return (
      <Box className={classes.container}>
        <Box className={classes.mobileView}>
          <Typography className="header">Pick your Plan and Payment</Typography>
          <Box className={classes.progressImage}>
            <img src={payment_start} alt="" />
          </Box>
        </Box>
        <Box style={webStyles.radioGroupBlock}>
          <RadioGroup
            data-test-id="planpaymentradio"
            row
            style={webStyles.radioButtons}
            name="plan"
            value={selectedPricing}
            onChange={(_, value) => setSelectedPricing(value as PlanPricing)}
          >
            <FormControlLabel
              data-test-id="annualPlan"
              classes={{
                root: `${classes.formLabel} ${selectedPricing ===
                  PlanPricing.Annual && classes.formLabelActive}`,
              }}
              value={PlanPricing.Annual}
              control={<StyledRadioBtn />}
              label={
                <Box display="flex" flexDirection="column" alignItems="center">
                  <Typography style={webStyles.discountText}>
                    <b>{configJSON.tenPercentSave}</b>
                  </Typography>
                   <Typography>
                    <b>Annual <span className={classes.hide}>Price</span></b>
                  </Typography>
                </Box>
              }
            />
            <Box style={webStyles.divider} />
            <FormControlLabel
              data-test-id="monthPlan"
              classes={{
                root: `${classes.formLabel} ${selectedPricing ===
                  PlanPricing.Month && classes.formLabelActive}`,
              }}
              value={PlanPricing.Month}
              control={<StyledRadioBtn />}
              label={
                <Typography>
                  <b>Monthly <span className={classes.hide}>Price</span></b>
                </Typography>
              }
            />
          </RadioGroup>
        </Box>

        <Box style={webStyles.planPaymentBlock}>
          <Container style={webStyles.mainContainerForm} className={classes.mainContainerForm}>
            {paymentPlanData
              ?.filter((paymentPlan: PaymentPlan) => {
                // ---- SPECIAL CASE: WAITLIST SHOULD NOT BE FILTERED ----
                if (paymentPlan?.attributes?.name?.toLowerCase() === "waitlist") {
                  return true;
                }

                // ---- EXISTING FILTER ----
                return paymentPlan?.attributes?.plans?.some((plan: any) =>
                  plan?.interval?.toLowerCase() === selectedPricing?.toLowerCase()
                );
              })
              ?.map((paymentPlan: PaymentPlan, index: number) => {

                // ===========================================================
                //               SPECIAL WAITLIST UI BLOCK
                // ===========================================================
                if (paymentPlan.attributes?.name?.toLowerCase() === "waitlist") {
                  return (
                    // <Box
                    //   key={"waitlist"}
                    //   data-test-id="waitlistPlan"
                    //   style={{
                    //     ...webStyles.paymentPlan,
                    //     background: "#F8FAFC",
                    //     border: "2px dashed #94A3B8",
                    //     padding: "25px",
                    //     borderRadius: "14px",
                    //   }}
                    // >
                    //   <Typography variant="h5" style={webStyles.titleText}>
                    //     Waitlist
                    //   </Typography>

                    //   <Typography
                    //     style={{
                    //       marginTop: "10px",
                    //       color: "#64748B",
                    //       fontSize: "16px",
                    //       fontStyle: "italic",
                    //     }}
                    //   >
                    //     You’re on the waitlist — we will notify you when plans are available.
                    //   </Typography>

                    //   <Typography
                    //     style={{
                    //       marginTop: "6px",
                    //       color: "#94A3B8",
                    //       fontSize: "14px",
                    //     }}
                    //   >
                    //     Pricing & features coming soon.
                    //   </Typography>

                    //   <Button
                    //     variant="contained"
                    //     fullWidth
                    //     disabled
                    //     style={{
                    //       marginTop: "20px",
                    //       background: "#CBD5E1",
                    //       color: "#475569",
                    //     }}
                    //   >
                    //     Waitlist
                    //   </Button>
                    // </Box>
                    <></>
                  );
                }

                // ===========================================================
                //                     NORMAL PLAN CARD
                // ===========================================================
                return (
                  <Box
                    data-test-id={paymentPlan.attributes.name}
                    key={paymentPlan.attributes.name}
                    style={{
                      ...webStyles.paymentPlan,
                      ...(activeBoxIndex === index ? { border: "6px solid #000000" } : {}),
                    }}
                    onClick={() => this.setActiveBoxIndex(index)}
                  >
                    <Typography variant="h5" style={webStyles.titleText}>
                      {paymentPlan.attributes.name}
                    </Typography>

                    <ul style={webStyles.descriptionList}>
                      <li>
                        <Typography style={webStyles.descriptionText}>
                          <b>{configJSON.bestFor}:</b>{" "}
                          {paymentPlan.attributes.description}
                        </Typography>
                      </li>
                    </ul>

                    {/* ================= PRICE BLOCK ================= */}
                    {this.getPriceValue(paymentPlan).price &&
                      paymentPlan?.attributes?.plans?.length > 0 ? (
                      <Box style={webStyles.priceBlock}>
                        <Typography data-test-id="planPrice" style={webStyles.price}>
                          $
                          <span style={webStyles.extraSize}>
                            {paymentPlan?.attributes?.plans?.length
                              ? Number(this.getPriceValue(paymentPlan)?.price ?? 0) +
                              Number(
                                this.planPriceVal(
                                  platformManagementPaymentPlans?.[0],
                                  selectedPricing
                                )?.price ?? 0
                              )
                              : Number(this.getPriceValue(paymentPlan)?.price ?? 0)}
                          </span>
                          <Box style={webStyles.priceAttributes}>
                            <Typography style={webStyles.priceCurrency}>
                              {this.getPriceValue(paymentPlan)?.currency || "USD"}
                            </Typography>
                            <Typography style={webStyles.priceInterval}>
                              {this.getPriceValue(paymentPlan)?.interval ||
                                selectedPricing}
                            </Typography>
                          </Box>
                        </Typography>
                      </Box>
                    ) : (
                      <Box style={webStyles.priceBlock}>
                        <Typography
                          variant="h5"
                          style={{
                            fontSize: "18px",
                            fontWeight: 600,
                            color: "#64748B",
                            fontStyle: "italic",
                            textAlign: "center",
                            padding: "20px 0",
                          }}
                        >
                          No pricing plans available
                        </Typography>

                        <Typography
                          style={{
                            fontSize: "14px",
                            color: "#94A3B8",
                            textAlign: "center",
                            marginTop: "5px",
                          }}
                        >
                          Contact support for pricing information
                        </Typography>
                      </Box>
                    )}

                    {/* ================= CONTACTS & MEMBERS ================= */}
                    <ul style={webStyles.hideMark}>
                      <li style={{ marginBottom: "21px" }}>
                        <Typography data-test-id="contactsLimitText">
                          <b>
                            {paymentPlan?.attributes?.service?.max_contacts_count ||
                              configJSON.config1000}{" "}
                            {configJSON.contacts}
                          </b>
                        </Typography>
                      </li>

                      <li style={{ marginBottom: "31px" }}>
                        <Typography data-test-id="membersLimitText">
                          <b>
                            {paymentPlan?.attributes?.service?.max_members_count ||
                              configJSON.upto3}{" "}
                            {configJSON.teamMembers}
                          </b>
                        </Typography>
                      </li>

                      <li>
                        <Typography>
                          <b>{configJSON.includes}</b>
                        </Typography>
                      </li>
                    </ul>

                    {/* PERMISSIONS */}
                    <ul style={webStyles.advantageList}>
                      {this.getPaymentPlan(paymentPlan)?.map(
                        (item: any, idx: number) => (
                          <li key={idx} style={webStyles.permissionText}>
                            {item}
                          </li>
                        )
                      )}
                    </ul>

                    {/* PLATFORM MANAGEMENT SWITCH */}
                    {paymentPlan.attributes.name !== "Essentials" && (
                      <Box className={classes.platformManagementContainer}>
                        <Box className={classes.infoContainer}>
                          <Box className={classes.iconContainer}>
                            <Info className={classes.infoIcon} />
                          </Box>
                          <Box className={classes.tooltip}>
                            <span className={classes.tooltipText}>
                              {this.platformManagementRegularTooltip}
                            </span>
                            <span>{this.platformManagementBoldTooltip}</span>
                          </Box>
                        </Box>

                        <Typography className={classes.platformManagementDescription}>
                          {this.addPlatformManagement}
                        </Typography>

                        <Switch
                          data-test-id={`planManagementSwitch-${paymentPlan.id}`}
                          onClick={() => setPlatformManagement(paymentPlan.id)}
                          checked={platformManagementChecked}
                          className={classes.platformManagementSwitch}
                          disableRipple
                        />
                      </Box>
                    )}

                    {/* SELECT BUTTON */}
                    <Button
                      data-test-id="selectButton"
                      variant="contained"
                      fullWidth
                      style={webStyles.selectBtn}
                      onClick={async () => {
                        if (!paymentPlan?.attributes?.plans?.length || !paymentPlan?.id) return;
                        
                        // Set loading state for this specific plan
                        this.setLoadingPlanId(paymentPlan.id);
                        
                        try {
                          // Call setSelectedPlan which may be async
                          await Promise.resolve(this.props.setSelectedPlan(paymentPlan));
                        } catch (error) {
                          console.error("Error selecting plan:", error);
                        } finally {
                          // Clear loading state after operation completes
                          // Note: The parent component may handle navigation/state changes
                          // so we clear loading after a short delay to ensure UI updates
                          setTimeout(() => {
                            this.setLoadingPlanId(null);
                          }, 500);
                        }
                      }}
                      disableElevation
                      disabled={!paymentPlan?.attributes?.plans?.length || loadingPlanId === paymentPlan.id}
                    >
                      {loadingPlanId === paymentPlan.id ? (
                        <Box display="flex" alignItems="center" justifyContent="center">
                          <CircularProgress size={20} style={{ color: "#0F172A", marginRight: "8px" }} />
                          <span>Loading...</span>
                        </Box>
                      ) : (
                        paymentPlan?.attributes?.plans?.length
                          ? configJSON.select
                          : "No Plans Available"
                      )}
                    </Button>
                  </Box>
                );
              })}

          </Container>
        </Box>
      </Box>
    );
  }
}

export { PlanPayment };
export default withStyles(styles)(PlanPayment);
// Customizable Area End
